import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Phase 27 — Minimal legal footer on every page (public + authenticated).
// Required by DSGVO / German Impressumspflicht.
export default function LegalFooter() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-white/5 mt-auto" data-testid="legal-footer">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-3">
        <div className="text-[10px] text-ink-muted">
          © {new Date().getFullYear()} StudioOps Food · Made in Austria
        </div>
        <nav className="flex items-center gap-4 text-[11px] text-ink-muted">
          <Link to="/impressum" className="hover:text-ink-secondary" data-testid="footer-impressum">
            {t("legal.impressum", "Impressum")}
          </Link>
          <Link to="/datenschutz" className="hover:text-ink-secondary" data-testid="footer-datenschutz">
            {t("legal.datenschutz", "Datenschutz")}
          </Link>
          <Link to="/agb" className="hover:text-ink-secondary" data-testid="footer-agb">
            {t("legal.agb", "AGB")}
          </Link>
        </nav>
      </div>
    </footer>
  );
}
